(function () {
  var property = '--bf-photo-edge-fill';

  function init(root) {
    root.querySelectorAll('[data-product-gallery="desktop"]').forEach(function (carousel) {
      if (carousel.dataset.bfPhotoFrame === 'true') return;
      carousel.dataset.bfPhotoFrame = 'true';
      var scheduled = 0;
      var lastKey = '';
      var lastFrame = null;
      var paintId = 0;
      var active = true;

      async function sync() {
        scheduled = 0;
        if (!active || !window.matchMedia('(min-width: 1008px)').matches) { paintId++; return; }
        var selected = carousel.querySelector('.Product__SlideItem--image.is-selected');
        var frame = selected && selected.querySelector('.AspectRatio');
        var photo = frame && frame.querySelector('img');
        if (!photo) return;
        if (!photo.complete || !photo.naturalWidth || !photo.naturalHeight) {
          paintId++;
          frame.style.removeProperty(property);
          frame.dataset.bfPhotoBackground = 'pending';
          lastFrame = null;
          lastKey = '';
          return;
        }
        var rect = frame.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var key = (photo.currentSrc || photo.src) + ':' + rect.width + ':' + rect.height;
        if (frame === lastFrame && key === lastKey) return;
        var token = ++paintId;
        var sourceUrl = photo.currentSrc || photo.src;
        var bitmap = null;
        function isCurrent() {
          var currentRect = frame.getBoundingClientRect();
          return active && token === paintId && window.matchMedia('(min-width: 1008px)').matches &&
            frame === carousel.querySelector('.Product__SlideItem--image.is-selected .AspectRatio') &&
            photo.complete && sourceUrl === (photo.currentSrc || photo.src) && currentRect.width === rect.width && currentRect.height === rect.height;
        }

        // Only extend the outermost source pixels into the unused margins.
        // The original <img> stays intact, sharp, and fitted with object-fit: contain.
        var canvas = document.createElement('canvas');
        var resolution = Math.min(1, 512 / Math.max(rect.width, rect.height));
        canvas.width = Math.max(1, Math.round(rect.width * resolution));
        canvas.height = Math.max(1, Math.round(rect.height * resolution));
        try {
          // Responsive images expose density-corrected naturalWidth; bitmap dimensions
          // are the actual source-pixel coordinates required by drawImage cropping.
          bitmap = await window.createImageBitmap(photo);
          if (!isCurrent()) return;
          var scale = Math.min(canvas.width / bitmap.width, canvas.height / bitmap.height);
          var width = bitmap.width * scale;
          var height = bitmap.height * scale;
          var left = (canvas.width - width) / 2;
          var top = (canvas.height - height) / 2;
          var context = canvas.getContext('2d');
          if (!context) throw new Error('Canvas unavailable');
          if (left > 0.1) {
            context.drawImage(bitmap, 0, 0, 1, bitmap.height, 0, top, left, height);
            context.drawImage(bitmap, bitmap.width - 1, 0, 1, bitmap.height, left + width, top, left, height);
          }
          if (top > 0.1) {
            context.drawImage(bitmap, 0, 0, bitmap.width, 1, left, 0, width, top);
            context.drawImage(bitmap, 0, bitmap.height - 1, bitmap.width, 1, left, top + height, width, top);
          }
          frame.style.setProperty(property, 'url("' + canvas.toDataURL('image/png') + '")');
          frame.dataset.bfPhotoBackground = 'ready';
          lastFrame = frame;
          lastKey = key;
        } catch (error) {
          if (isCurrent()) {
            frame.style.removeProperty(property);
            frame.dataset.bfPhotoBackground = 'unavailable';
          }
        } finally {
          if (bitmap) bitmap.close();
        }
      }

      function schedule() {
        if (!scheduled) scheduled = window.requestAnimationFrame(sync);
      }
      var mutation = new MutationObserver(schedule);
      mutation.observe(carousel, { attributes: true, attributeFilter: ['class', 'src', 'srcset'], childList: true, subtree: true });
      var resize = window.ResizeObserver && new ResizeObserver(schedule);
      if (resize) resize.observe(carousel);
      carousel.addEventListener('load', schedule, true);
      window.addEventListener('resize', schedule, { passive: true });
      var section = carousel.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', function () {
        active = false;
        paintId++;
        mutation.disconnect();
        if (resize) resize.disconnect();
        carousel.removeEventListener('load', schedule, true);
        window.removeEventListener('resize', schedule);
        if (scheduled) window.cancelAnimationFrame(scheduled);
      }, { once: true });
      schedule();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
